/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_SHELF_LIST = gql`
  query GetShelves(
    $options: GetManyOptions
    $filter: ShelfFilterInput
    $distFilter: DistCentFilterInput
  ) {
    getShelves(options: $options, filter: $filter) {
      count
      content {
        activeStatus
        createdAt
        distCent {
          name
          id
        }
        id

        shelfDeliveryStatus
        shelfId
        name
        updatedAt
        boxes {
          id
          costumeID
          masqID
          isVIP
          deliveryStatus
        }
      }
      limit
      skip
    }

    getDistCents(filter: $distFilter) {
      content {
        distCenterId
        id
        name
        noOfCounters
      }
    }
  }
`;
